__turbopack_context__.v({
  "bl": "FindObjectEditor-module-scss-module__p9lqyq__bl",
  "br": "FindObjectEditor-module-scss-module__p9lqyq__br",
  "container": "FindObjectEditor-module-scss-module__p9lqyq__container",
  "image": "FindObjectEditor-module-scss-module__p9lqyq__image",
  "root": "FindObjectEditor-module-scss-module__p9lqyq__root",
  "stage": "FindObjectEditor-module-scss-module__p9lqyq__stage",
  "stageViewport": "FindObjectEditor-module-scss-module__p9lqyq__stageViewport",
  "target": "FindObjectEditor-module-scss-module__p9lqyq__target",
  "targetBorder": "FindObjectEditor-module-scss-module__p9lqyq__targetBorder",
  "targetCorner": "FindObjectEditor-module-scss-module__p9lqyq__targetCorner",
  "tl": "FindObjectEditor-module-scss-module__p9lqyq__tl",
  "tr": "FindObjectEditor-module-scss-module__p9lqyq__tr",
});
